import { Link } from "react-router-dom";
import { useSeo } from "../lib/useSeo";

export default function NotFound() {
  useSeo("Page not found", "The page you’re looking for doesn’t exist or may have moved.");
  return (
    <section
      data-testid="not-found"
      className="max-w-[1200px] mx-auto px-6 md:px-10 py-28 md:py-40 text-center"
    >
      <p className="amf-overline text-amf-burgundy mb-4">Error 404</p>
      <h1 className="font-playfair text-4xl md:text-6xl text-amf-navy mb-5">
        Page not found
      </h1>
      <p className="font-lora text-lg text-amf-charcoal/80 max-w-xl mx-auto mb-10">
        The page you’re looking for doesn’t exist or may have moved. Let’s get
        you back on track.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center font-inter uppercase tracking-[0.18em] text-sm bg-amf-burgundy text-[var(--amf-accent-fg,#fff)] px-8 py-3.5 hover:bg-[var(--amf-accent-dark)] transition-colors"
      >
        Back to home
      </Link>
    </section>
  );
}
